import styled from 'styled-components';
import ReactSelect from 'react-select';

import { colourPrimaryLight, colourMasterSemiLight, colourMasterDarker } from 'Styles/colors.css';

const Select = styled(ReactSelect)`

  .Select-control {
    border: 1px solid rgba(0, 0, 0, .07) !important;
    box-shadow: none !important;
    border-radius: 2px;
  }

  .Select-menu-outer {
    border: 1px solid rgba(0, 0, 0, .07);
    border-radius: 2px;
  }

  .Select-option.is-focused {
    background-color: ${colourPrimaryLight};
  }

  &.is-disabled * {
    color: ${colourMasterSemiLight} !important;
  }

  &:not(.is-disabled) * {
    color: ${colourMasterDarker} !important;
  }
`;

export default Select;



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/style.js